(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
"use strict";
var $2cbb2feed11b0c82$exports = {};
"use strict";
var $2cbb2feed11b0c82$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$2cbb2feed11b0c82$exports = // eslint-disable-next-line es/no-global-this -- safe
$2cbb2feed11b0c82$var$check(typeof globalThis == "object" && globalThis) || $2cbb2feed11b0c82$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$2cbb2feed11b0c82$var$check(typeof self == "object" && self) || $2cbb2feed11b0c82$var$check(typeof $parcel$global == "object" && $parcel$global) || $2cbb2feed11b0c82$var$check(typeof $2cbb2feed11b0c82$exports == "object" && $2cbb2feed11b0c82$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $9ff00bcaf2233381$exports = {};
"use strict";
var $559f5eda2886c38a$exports = {};
"use strict";
$559f5eda2886c38a$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$9ff00bcaf2233381$exports = !$559f5eda2886c38a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $a5dd190846fc6491$exports = {};
"use strict";
var $e0932d959165c5aa$exports = {};
"use strict";
var $034d34ba5c67196d$exports = {};
"use strict";
var $2b364aaec2774fa2$exports = {};
"use strict";

$2b364aaec2774fa2$exports = !$559f5eda2886c38a$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $034d34ba5c67196d$var$FunctionPrototype = Function.prototype;
var $034d34ba5c67196d$var$call = $034d34ba5c67196d$var$FunctionPrototype.call;
var $034d34ba5c67196d$var$uncurryThisWithBind = $2b364aaec2774fa2$exports && $034d34ba5c67196d$var$FunctionPrototype.bind.bind($034d34ba5c67196d$var$call, $034d34ba5c67196d$var$call);
$034d34ba5c67196d$exports = $2b364aaec2774fa2$exports ? $034d34ba5c67196d$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $034d34ba5c67196d$var$call.apply(fn, arguments);
    };
};



var $7bfc98a4d0d840f1$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $7bfc98a4d0d840f1$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$7bfc98a4d0d840f1$exports = typeof $7bfc98a4d0d840f1$var$documentAll == "undefined" && $7bfc98a4d0d840f1$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $7bfc98a4d0d840f1$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $b15a118d07a83660$exports = {};
"use strict";

var $f044d2da435198e8$exports = {};
"use strict";
var $ffc260fd1baed7a7$exports = {};
"use strict";
var $24641a7b94c63f9e$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$24641a7b94c63f9e$exports = function(it) {
    return it === null || it === undefined;
};


var $ffc260fd1baed7a7$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ffc260fd1baed7a7$exports = function(it) {
    if ($24641a7b94c63f9e$exports(it)) throw new $ffc260fd1baed7a7$var$$TypeError("Can't call method on " + it);
    return it;
};


var $f044d2da435198e8$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$f044d2da435198e8$exports = function(argument) {
    return $f044d2da435198e8$var$$Object($ffc260fd1baed7a7$exports(argument));
};


var $b15a118d07a83660$var$hasOwnProperty = $034d34ba5c67196d$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$b15a118d07a83660$exports = Object.hasOwn || function hasOwn(it, key) {
    return $b15a118d07a83660$var$hasOwnProperty($f044d2da435198e8$exports(it), key);
};



var $2397ef5045960f6e$exports = {};
"use strict";


var $2397ef5045960f6e$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2397ef5045960f6e$var$getDescriptor = $9ff00bcaf2233381$exports && Object.getOwnPropertyDescriptor;
var $2397ef5045960f6e$var$EXISTS = $b15a118d07a83660$exports($2397ef5045960f6e$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $2397ef5045960f6e$var$PROPER = $2397ef5045960f6e$var$EXISTS && (function something() {}).name === "something";
var $2397ef5045960f6e$var$CONFIGURABLE = $2397ef5045960f6e$var$EXISTS && (!$9ff00bcaf2233381$exports || $9ff00bcaf2233381$exports && $2397ef5045960f6e$var$getDescriptor($2397ef5045960f6e$var$FunctionPrototype, "name").configurable);
$2397ef5045960f6e$exports = {
    EXISTS: $2397ef5045960f6e$var$EXISTS,
    PROPER: $2397ef5045960f6e$var$PROPER,
    CONFIGURABLE: $2397ef5045960f6e$var$CONFIGURABLE
};


var $e0932d959165c5aa$require$CONFIGURABLE_FUNCTION_NAME = $2397ef5045960f6e$exports.CONFIGURABLE;
var $dce6bc00dbe06f37$exports = {};
"use strict";


var $cc86a965af88125c$exports = {};
"use strict";
var $9eb3ce4fdbd93d1a$exports = {};
"use strict";
$9eb3ce4fdbd93d1a$exports = false;



var $8a688362be0e540d$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8a688362be0e540d$var$defineProperty = Object.defineProperty;
$8a688362be0e540d$exports = function(key, value) {
    try {
        $8a688362be0e540d$var$defineProperty($2cbb2feed11b0c82$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $2cbb2feed11b0c82$exports[key] = value;
    }
    return value;
};


var $cc86a965af88125c$var$SHARED = "__core-js_shared__";
var $cc86a965af88125c$var$store = $cc86a965af88125c$exports = $2cbb2feed11b0c82$exports[$cc86a965af88125c$var$SHARED] || $8a688362be0e540d$exports($cc86a965af88125c$var$SHARED, {});
($cc86a965af88125c$var$store.versions || ($cc86a965af88125c$var$store.versions = [])).push({
    version: "3.36.0",
    mode: $9eb3ce4fdbd93d1a$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.36.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $dce6bc00dbe06f37$var$functionToString = $034d34ba5c67196d$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$7bfc98a4d0d840f1$exports($cc86a965af88125c$exports.inspectSource)) $cc86a965af88125c$exports.inspectSource = function(it) {
    return $dce6bc00dbe06f37$var$functionToString(it);
};
$dce6bc00dbe06f37$exports = $cc86a965af88125c$exports.inspectSource;


var $c44f16fccfe2679a$exports = {};
"use strict";
var $01376a5988e2cd0e$exports = {};
"use strict";


var $01376a5988e2cd0e$var$WeakMap = $2cbb2feed11b0c82$exports.WeakMap;
$01376a5988e2cd0e$exports = $7bfc98a4d0d840f1$exports($01376a5988e2cd0e$var$WeakMap) && /native code/.test(String($01376a5988e2cd0e$var$WeakMap));



var $1dd48fec02de1ab9$exports = {};
"use strict";

$1dd48fec02de1ab9$exports = function(it) {
    return typeof it == "object" ? it !== null : $7bfc98a4d0d840f1$exports(it);
};


var $20d431cd936788d2$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $385c93b930cc413c$export$2d1720544b23b823;
"use strict";

var $669235fed8991415$exports = {};
"use strict";


var $5307871634ee9684$exports = {};
"use strict";


var $5307871634ee9684$var$document = $2cbb2feed11b0c82$exports.document;
// typeof document.createElement is 'object' in old IE
var $5307871634ee9684$var$EXISTS = $1dd48fec02de1ab9$exports($5307871634ee9684$var$document) && $1dd48fec02de1ab9$exports($5307871634ee9684$var$document.createElement);
$5307871634ee9684$exports = function(it) {
    return $5307871634ee9684$var$EXISTS ? $5307871634ee9684$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$669235fed8991415$exports = !$9ff00bcaf2233381$exports && !$559f5eda2886c38a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($5307871634ee9684$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $fd9659999e2144a6$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$fd9659999e2144a6$exports = $9ff00bcaf2233381$exports && $559f5eda2886c38a$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $bdf4e31e832353ba$exports = {};
"use strict";

var $bdf4e31e832353ba$var$$String = String;
var $bdf4e31e832353ba$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$bdf4e31e832353ba$exports = function(argument) {
    if ($1dd48fec02de1ab9$exports(argument)) return argument;
    throw new $bdf4e31e832353ba$var$$TypeError($bdf4e31e832353ba$var$$String(argument) + " is not an object");
};


var $1f05d412889afb5f$exports = {};
"use strict";
var $1630a15cebc1c2d7$exports = {};
"use strict";
var $435486dccf283463$exports = {};
"use strict";

var $435486dccf283463$var$call = Function.prototype.call;
$435486dccf283463$exports = $2b364aaec2774fa2$exports ? $435486dccf283463$var$call.bind($435486dccf283463$var$call) : function() {
    return $435486dccf283463$var$call.apply($435486dccf283463$var$call, arguments);
};



var $0b30e72fa2aa0836$exports = {};
"use strict";
var $8eca1fe746def71f$exports = {};
"use strict";


var $8eca1fe746def71f$var$aFunction = function(argument) {
    return $7bfc98a4d0d840f1$exports(argument) ? argument : undefined;
};
$8eca1fe746def71f$exports = function(namespace, method) {
    return arguments.length < 2 ? $8eca1fe746def71f$var$aFunction($2cbb2feed11b0c82$exports[namespace]) : $2cbb2feed11b0c82$exports[namespace] && $2cbb2feed11b0c82$exports[namespace][method];
};



var $06399b182ca2f89f$exports = {};
"use strict";

$06399b182ca2f89f$exports = $034d34ba5c67196d$exports({}.isPrototypeOf);


var $e41669fc654e36c2$exports = {};
"use strict";
var $fba9a764841392ee$exports = {};
"use strict";
var $8da44072739d9f2f$exports = {};
"use strict";

var $ddf1d285fb7076b6$exports = {};
"use strict";
$ddf1d285fb7076b6$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $8da44072739d9f2f$var$process = $2cbb2feed11b0c82$exports.process;
var $8da44072739d9f2f$var$Deno = $2cbb2feed11b0c82$exports.Deno;
var $8da44072739d9f2f$var$versions = $8da44072739d9f2f$var$process && $8da44072739d9f2f$var$process.versions || $8da44072739d9f2f$var$Deno && $8da44072739d9f2f$var$Deno.version;
var $8da44072739d9f2f$var$v8 = $8da44072739d9f2f$var$versions && $8da44072739d9f2f$var$versions.v8;
var $8da44072739d9f2f$var$match, $8da44072739d9f2f$var$version;
if ($8da44072739d9f2f$var$v8) {
    $8da44072739d9f2f$var$match = $8da44072739d9f2f$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $8da44072739d9f2f$var$version = $8da44072739d9f2f$var$match[0] > 0 && $8da44072739d9f2f$var$match[0] < 4 ? 1 : +($8da44072739d9f2f$var$match[0] + $8da44072739d9f2f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$8da44072739d9f2f$var$version && $ddf1d285fb7076b6$exports) {
    $8da44072739d9f2f$var$match = $ddf1d285fb7076b6$exports.match(/Edge\/(\d+)/);
    if (!$8da44072739d9f2f$var$match || $8da44072739d9f2f$var$match[1] >= 74) {
        $8da44072739d9f2f$var$match = $ddf1d285fb7076b6$exports.match(/Chrome\/(\d+)/);
        if ($8da44072739d9f2f$var$match) $8da44072739d9f2f$var$version = +$8da44072739d9f2f$var$match[1];
    }
}
$8da44072739d9f2f$exports = $8da44072739d9f2f$var$version;




var $fba9a764841392ee$var$$String = $2cbb2feed11b0c82$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$fba9a764841392ee$exports = !!Object.getOwnPropertySymbols && !$559f5eda2886c38a$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$fba9a764841392ee$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $8da44072739d9f2f$exports && $8da44072739d9f2f$exports < 41;
});


$e41669fc654e36c2$exports = $fba9a764841392ee$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0b30e72fa2aa0836$var$$Object = Object;
$0b30e72fa2aa0836$exports = $e41669fc654e36c2$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $8eca1fe746def71f$exports("Symbol");
    return $7bfc98a4d0d840f1$exports($Symbol) && $06399b182ca2f89f$exports($Symbol.prototype, $0b30e72fa2aa0836$var$$Object(it));
};


var $54bedcc02ecf5cef$exports = {};
"use strict";
var $cbc0300673cdb7ee$exports = {};
"use strict";

var $dc76b497a74b3a94$exports = {};
"use strict";
var $dc76b497a74b3a94$var$$String = String;
$dc76b497a74b3a94$exports = function(argument) {
    try {
        return $dc76b497a74b3a94$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $cbc0300673cdb7ee$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$cbc0300673cdb7ee$exports = function(argument) {
    if ($7bfc98a4d0d840f1$exports(argument)) return argument;
    throw new $cbc0300673cdb7ee$var$$TypeError($dc76b497a74b3a94$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$54bedcc02ecf5cef$exports = function(V, P) {
    var func = V[P];
    return $24641a7b94c63f9e$exports(func) ? undefined : $cbc0300673cdb7ee$exports(func);
};


var $f478513d9b736e6e$exports = {};
"use strict";



var $f478513d9b736e6e$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$f478513d9b736e6e$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $7bfc98a4d0d840f1$exports(fn = input.toString) && !$1dd48fec02de1ab9$exports(val = $435486dccf283463$exports(fn, input))) return val;
    if ($7bfc98a4d0d840f1$exports(fn = input.valueOf) && !$1dd48fec02de1ab9$exports(val = $435486dccf283463$exports(fn, input))) return val;
    if (pref !== "string" && $7bfc98a4d0d840f1$exports(fn = input.toString) && !$1dd48fec02de1ab9$exports(val = $435486dccf283463$exports(fn, input))) return val;
    throw new $f478513d9b736e6e$var$$TypeError("Can't convert object to primitive value");
};


var $efbc5aee6a096e27$exports = {};
"use strict";

var $83dffb9d64875d64$exports = {};
"use strict";

$83dffb9d64875d64$exports = function(key, value) {
    return $cc86a965af88125c$exports[key] || ($cc86a965af88125c$exports[key] = value || {});
};



var $f87e4ac2c1fa83ae$exports = {};
"use strict";

var $f87e4ac2c1fa83ae$var$id = 0;
var $f87e4ac2c1fa83ae$var$postfix = Math.random();
var $f87e4ac2c1fa83ae$var$toString = $034d34ba5c67196d$exports(1.0.toString);
$f87e4ac2c1fa83ae$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $f87e4ac2c1fa83ae$var$toString(++$f87e4ac2c1fa83ae$var$id + $f87e4ac2c1fa83ae$var$postfix, 36);
};




var $efbc5aee6a096e27$var$Symbol = $2cbb2feed11b0c82$exports.Symbol;
var $efbc5aee6a096e27$var$WellKnownSymbolsStore = $83dffb9d64875d64$exports("wks");
var $efbc5aee6a096e27$var$createWellKnownSymbol = $e41669fc654e36c2$exports ? $efbc5aee6a096e27$var$Symbol["for"] || $efbc5aee6a096e27$var$Symbol : $efbc5aee6a096e27$var$Symbol && $efbc5aee6a096e27$var$Symbol.withoutSetter || $f87e4ac2c1fa83ae$exports;
$efbc5aee6a096e27$exports = function(name) {
    if (!$b15a118d07a83660$exports($efbc5aee6a096e27$var$WellKnownSymbolsStore, name)) $efbc5aee6a096e27$var$WellKnownSymbolsStore[name] = $fba9a764841392ee$exports && $b15a118d07a83660$exports($efbc5aee6a096e27$var$Symbol, name) ? $efbc5aee6a096e27$var$Symbol[name] : $efbc5aee6a096e27$var$createWellKnownSymbol("Symbol." + name);
    return $efbc5aee6a096e27$var$WellKnownSymbolsStore[name];
};


var $1630a15cebc1c2d7$var$$TypeError = TypeError;
var $1630a15cebc1c2d7$var$TO_PRIMITIVE = $efbc5aee6a096e27$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$1630a15cebc1c2d7$exports = function(input, pref) {
    if (!$1dd48fec02de1ab9$exports(input) || $0b30e72fa2aa0836$exports(input)) return input;
    var exoticToPrim = $54bedcc02ecf5cef$exports(input, $1630a15cebc1c2d7$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $435486dccf283463$exports(exoticToPrim, input, pref);
        if (!$1dd48fec02de1ab9$exports(result) || $0b30e72fa2aa0836$exports(result)) return result;
        throw new $1630a15cebc1c2d7$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $f478513d9b736e6e$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$1f05d412889afb5f$exports = function(argument) {
    var key = $1630a15cebc1c2d7$exports(argument, "string");
    return $0b30e72fa2aa0836$exports(key) ? key : key + "";
};


var $385c93b930cc413c$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $385c93b930cc413c$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $385c93b930cc413c$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $385c93b930cc413c$var$ENUMERABLE = "enumerable";
var $385c93b930cc413c$var$CONFIGURABLE = "configurable";
var $385c93b930cc413c$var$WRITABLE = "writable";
$385c93b930cc413c$export$2d1720544b23b823 = $9ff00bcaf2233381$exports ? $fd9659999e2144a6$exports ? function defineProperty(O, P, Attributes) {
    $bdf4e31e832353ba$exports(O);
    P = $1f05d412889afb5f$exports(P);
    $bdf4e31e832353ba$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $385c93b930cc413c$var$WRITABLE in Attributes && !Attributes[$385c93b930cc413c$var$WRITABLE]) {
        var current = $385c93b930cc413c$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$385c93b930cc413c$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $385c93b930cc413c$var$CONFIGURABLE in Attributes ? Attributes[$385c93b930cc413c$var$CONFIGURABLE] : current[$385c93b930cc413c$var$CONFIGURABLE],
                enumerable: $385c93b930cc413c$var$ENUMERABLE in Attributes ? Attributes[$385c93b930cc413c$var$ENUMERABLE] : current[$385c93b930cc413c$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $385c93b930cc413c$var$$defineProperty(O, P, Attributes);
} : $385c93b930cc413c$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $bdf4e31e832353ba$exports(O);
    P = $1f05d412889afb5f$exports(P);
    $bdf4e31e832353ba$exports(Attributes);
    if ($669235fed8991415$exports) try {
        return $385c93b930cc413c$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $385c93b930cc413c$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $5fae5d41462f758e$exports = {};
"use strict";
$5fae5d41462f758e$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$20d431cd936788d2$exports = $9ff00bcaf2233381$exports ? function(object, key, value) {
    return $385c93b930cc413c$export$2d1720544b23b823(object, key, $5fae5d41462f758e$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $0735933ea8671f84$exports = {};
"use strict";


var $0735933ea8671f84$var$keys = $83dffb9d64875d64$exports("keys");
$0735933ea8671f84$exports = function(key) {
    return $0735933ea8671f84$var$keys[key] || ($0735933ea8671f84$var$keys[key] = $f87e4ac2c1fa83ae$exports(key));
};


var $b1e7c6c731f3486d$exports = {};
"use strict";
$b1e7c6c731f3486d$exports = {};


var $c44f16fccfe2679a$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $c44f16fccfe2679a$var$TypeError = $2cbb2feed11b0c82$exports.TypeError;
var $c44f16fccfe2679a$var$WeakMap = $2cbb2feed11b0c82$exports.WeakMap;
var $c44f16fccfe2679a$var$set, $c44f16fccfe2679a$var$get, $c44f16fccfe2679a$var$has;
var $c44f16fccfe2679a$var$enforce = function(it) {
    return $c44f16fccfe2679a$var$has(it) ? $c44f16fccfe2679a$var$get(it) : $c44f16fccfe2679a$var$set(it, {});
};
var $c44f16fccfe2679a$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$1dd48fec02de1ab9$exports(it) || (state = $c44f16fccfe2679a$var$get(it)).type !== TYPE) throw new $c44f16fccfe2679a$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($01376a5988e2cd0e$exports || $cc86a965af88125c$exports.state) {
    var $c44f16fccfe2679a$var$store = $cc86a965af88125c$exports.state || ($cc86a965af88125c$exports.state = new $c44f16fccfe2679a$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $c44f16fccfe2679a$var$store.get = $c44f16fccfe2679a$var$store.get;
    $c44f16fccfe2679a$var$store.has = $c44f16fccfe2679a$var$store.has;
    $c44f16fccfe2679a$var$store.set = $c44f16fccfe2679a$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $c44f16fccfe2679a$var$set = function(it, metadata) {
        if ($c44f16fccfe2679a$var$store.has(it)) throw new $c44f16fccfe2679a$var$TypeError($c44f16fccfe2679a$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $c44f16fccfe2679a$var$store.set(it, metadata);
        return metadata;
    };
    $c44f16fccfe2679a$var$get = function(it) {
        return $c44f16fccfe2679a$var$store.get(it) || {};
    };
    $c44f16fccfe2679a$var$has = function(it) {
        return $c44f16fccfe2679a$var$store.has(it);
    };
} else {
    var $c44f16fccfe2679a$var$STATE = $0735933ea8671f84$exports("state");
    $b1e7c6c731f3486d$exports[$c44f16fccfe2679a$var$STATE] = true;
    $c44f16fccfe2679a$var$set = function(it, metadata) {
        if ($b15a118d07a83660$exports(it, $c44f16fccfe2679a$var$STATE)) throw new $c44f16fccfe2679a$var$TypeError($c44f16fccfe2679a$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $20d431cd936788d2$exports(it, $c44f16fccfe2679a$var$STATE, metadata);
        return metadata;
    };
    $c44f16fccfe2679a$var$get = function(it) {
        return $b15a118d07a83660$exports(it, $c44f16fccfe2679a$var$STATE) ? it[$c44f16fccfe2679a$var$STATE] : {};
    };
    $c44f16fccfe2679a$var$has = function(it) {
        return $b15a118d07a83660$exports(it, $c44f16fccfe2679a$var$STATE);
    };
}
$c44f16fccfe2679a$exports = {
    set: $c44f16fccfe2679a$var$set,
    get: $c44f16fccfe2679a$var$get,
    has: $c44f16fccfe2679a$var$has,
    enforce: $c44f16fccfe2679a$var$enforce,
    getterFor: $c44f16fccfe2679a$var$getterFor
};


var $e0932d959165c5aa$var$enforceInternalState = $c44f16fccfe2679a$exports.enforce;
var $e0932d959165c5aa$var$getInternalState = $c44f16fccfe2679a$exports.get;
var $e0932d959165c5aa$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e0932d959165c5aa$var$defineProperty = Object.defineProperty;
var $e0932d959165c5aa$var$stringSlice = $034d34ba5c67196d$exports("".slice);
var $e0932d959165c5aa$var$replace = $034d34ba5c67196d$exports("".replace);
var $e0932d959165c5aa$var$join = $034d34ba5c67196d$exports([].join);
var $e0932d959165c5aa$var$CONFIGURABLE_LENGTH = $9ff00bcaf2233381$exports && !$559f5eda2886c38a$exports(function() {
    return $e0932d959165c5aa$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $e0932d959165c5aa$var$TEMPLATE = String(String).split("String");
var $e0932d959165c5aa$var$makeBuiltIn = $e0932d959165c5aa$exports = function(value, name, options) {
    if ($e0932d959165c5aa$var$stringSlice($e0932d959165c5aa$var$$String(name), 0, 7) === "Symbol(") name = "[" + $e0932d959165c5aa$var$replace($e0932d959165c5aa$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$b15a118d07a83660$exports(value, "name") || $e0932d959165c5aa$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($9ff00bcaf2233381$exports) $e0932d959165c5aa$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($e0932d959165c5aa$var$CONFIGURABLE_LENGTH && options && $b15a118d07a83660$exports(options, "arity") && value.length !== options.arity) $e0932d959165c5aa$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $b15a118d07a83660$exports(options, "constructor") && options.constructor) {
            if ($9ff00bcaf2233381$exports) $e0932d959165c5aa$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $e0932d959165c5aa$var$enforceInternalState(value);
    if (!$b15a118d07a83660$exports(state, "source")) state.source = $e0932d959165c5aa$var$join($e0932d959165c5aa$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $e0932d959165c5aa$var$makeBuiltIn(function toString() {
    return $7bfc98a4d0d840f1$exports(this) && $e0932d959165c5aa$var$getInternalState(this).source || $dce6bc00dbe06f37$exports(this);
}, "toString");



$a5dd190846fc6491$exports = function(target, name, descriptor) {
    if (descriptor.get) $e0932d959165c5aa$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $e0932d959165c5aa$exports(descriptor.set, name, {
        setter: true
    });
    return $385c93b930cc413c$export$2d1720544b23b823(target, name, descriptor);
};


var $8e623daf85b16b0f$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$8e623daf85b16b0f$exports = function() {
    var that = $bdf4e31e832353ba$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $7a2c16e73bb385ec$var$RegExp = $2cbb2feed11b0c82$exports.RegExp;
var $7a2c16e73bb385ec$var$RegExpPrototype = $7a2c16e73bb385ec$var$RegExp.prototype;
var $7a2c16e73bb385ec$var$FORCED = $9ff00bcaf2233381$exports && $559f5eda2886c38a$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $7a2c16e73bb385ec$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($7a2c16e73bb385ec$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($7a2c16e73bb385ec$var$FORCED) $a5dd190846fc6491$exports($7a2c16e73bb385ec$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $8e623daf85b16b0f$exports
});


"use strict";


var $7a7e22a3f2bb1ff4$exports = {};
"use strict";
var $66dc380d9851576a$exports = {};
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
$66dc380d9851576a$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";







var $971adb0860c4a3ee$exports = {};
"use strict";
var $ffc34db16d975d38$exports = {};
"use strict";

var $ffc34db16d975d38$var$TO_STRING_TAG = $efbc5aee6a096e27$exports("toStringTag");
var $ffc34db16d975d38$var$test = {};
$ffc34db16d975d38$var$test[$ffc34db16d975d38$var$TO_STRING_TAG] = "z";
$ffc34db16d975d38$exports = String($ffc34db16d975d38$var$test) === "[object z]";



var $fccbf27112ab4253$exports = {};
"use strict";

var $fccbf27112ab4253$var$toString = $034d34ba5c67196d$exports({}.toString);
var $fccbf27112ab4253$var$stringSlice = $034d34ba5c67196d$exports("".slice);
$fccbf27112ab4253$exports = function(it) {
    return $fccbf27112ab4253$var$stringSlice($fccbf27112ab4253$var$toString(it), 8, -1);
};



var $971adb0860c4a3ee$var$TO_STRING_TAG = $efbc5aee6a096e27$exports("toStringTag");
var $971adb0860c4a3ee$var$$Object = Object;
// ES3 wrong here
var $971adb0860c4a3ee$var$CORRECT_ARGUMENTS = $fccbf27112ab4253$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $971adb0860c4a3ee$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$971adb0860c4a3ee$exports = $ffc34db16d975d38$exports ? $fccbf27112ab4253$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $971adb0860c4a3ee$var$tryGet(O = $971adb0860c4a3ee$var$$Object(it), $971adb0860c4a3ee$var$TO_STRING_TAG)) == "string" ? tag : $971adb0860c4a3ee$var$CORRECT_ARGUMENTS ? $fccbf27112ab4253$exports(O) : (result = $fccbf27112ab4253$exports(O)) === "Object" && $7bfc98a4d0d840f1$exports(O.callee) ? "Arguments" : result;
};




var $e96fa61102c8705a$exports = {};
"use strict";




$e96fa61102c8705a$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($7bfc98a4d0d840f1$exports(value)) $e0932d959165c5aa$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $8a688362be0e540d$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $385c93b930cc413c$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $c33537b177d6dc45$exports = {};
"use strict";




var $0ef3af9f4b81518b$exports = {};
"use strict";

$0ef3af9f4b81518b$exports = !$559f5eda2886c38a$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $c33537b177d6dc45$var$IE_PROTO = $0735933ea8671f84$exports("IE_PROTO");
var $c33537b177d6dc45$var$$Object = Object;
var $c33537b177d6dc45$var$ObjectPrototype = $c33537b177d6dc45$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$c33537b177d6dc45$exports = $0ef3af9f4b81518b$exports ? $c33537b177d6dc45$var$$Object.getPrototypeOf : function(O) {
    var object = $f044d2da435198e8$exports(O);
    if ($b15a118d07a83660$exports(object, $c33537b177d6dc45$var$IE_PROTO)) return object[$c33537b177d6dc45$var$IE_PROTO];
    var constructor = object.constructor;
    if ($7bfc98a4d0d840f1$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $c33537b177d6dc45$var$$Object ? $c33537b177d6dc45$var$ObjectPrototype : null;
};


var $4ca5bf3591a2dc30$exports = {};
"use strict";
var $bfbf8e560367cee9$exports = {};
"use strict";


$bfbf8e560367cee9$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $034d34ba5c67196d$exports($cbc0300673cdb7ee$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $dea128757afeb08d$exports = {};
"use strict";
var $3687499ab176e422$exports = {};
"use strict";

$3687499ab176e422$exports = function(argument) {
    return $1dd48fec02de1ab9$exports(argument) || argument === null;
};


var $dea128757afeb08d$var$$String = String;
var $dea128757afeb08d$var$$TypeError = TypeError;
$dea128757afeb08d$exports = function(argument) {
    if ($3687499ab176e422$exports(argument)) return argument;
    throw new $dea128757afeb08d$var$$TypeError("Can't set " + $dea128757afeb08d$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$4ca5bf3591a2dc30$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $bfbf8e560367cee9$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $bdf4e31e832353ba$exports(O);
        $dea128757afeb08d$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $7a7e22a3f2bb1ff4$var$enforceInternalState = $c44f16fccfe2679a$exports.enforce;
var $7a7e22a3f2bb1ff4$var$getInternalState = $c44f16fccfe2679a$exports.get;
var $7a7e22a3f2bb1ff4$var$Int8Array = $2cbb2feed11b0c82$exports.Int8Array;
var $7a7e22a3f2bb1ff4$var$Int8ArrayPrototype = $7a7e22a3f2bb1ff4$var$Int8Array && $7a7e22a3f2bb1ff4$var$Int8Array.prototype;
var $7a7e22a3f2bb1ff4$var$Uint8ClampedArray = $2cbb2feed11b0c82$exports.Uint8ClampedArray;
var $7a7e22a3f2bb1ff4$var$Uint8ClampedArrayPrototype = $7a7e22a3f2bb1ff4$var$Uint8ClampedArray && $7a7e22a3f2bb1ff4$var$Uint8ClampedArray.prototype;
var $7a7e22a3f2bb1ff4$var$TypedArray = $7a7e22a3f2bb1ff4$var$Int8Array && $c33537b177d6dc45$exports($7a7e22a3f2bb1ff4$var$Int8Array);
var $7a7e22a3f2bb1ff4$var$TypedArrayPrototype = $7a7e22a3f2bb1ff4$var$Int8ArrayPrototype && $c33537b177d6dc45$exports($7a7e22a3f2bb1ff4$var$Int8ArrayPrototype);
var $7a7e22a3f2bb1ff4$var$ObjectPrototype = Object.prototype;
var $7a7e22a3f2bb1ff4$var$TypeError = $2cbb2feed11b0c82$exports.TypeError;
var $7a7e22a3f2bb1ff4$var$TO_STRING_TAG = $efbc5aee6a096e27$exports("toStringTag");
var $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG = $f87e4ac2c1fa83ae$exports("TYPED_ARRAY_TAG");
var $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS = $66dc380d9851576a$exports && !!$4ca5bf3591a2dc30$exports && $971adb0860c4a3ee$exports($2cbb2feed11b0c82$exports.opera) !== "Opera";
var $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $7a7e22a3f2bb1ff4$var$NAME, $7a7e22a3f2bb1ff4$var$Constructor, $7a7e22a3f2bb1ff4$var$Prototype;
var $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $7a7e22a3f2bb1ff4$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $7a7e22a3f2bb1ff4$var$isView = function isView(it) {
    if (!$1dd48fec02de1ab9$exports(it)) return false;
    var klass = $971adb0860c4a3ee$exports(it);
    return klass === "DataView" || $b15a118d07a83660$exports($7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList, klass) || $b15a118d07a83660$exports($7a7e22a3f2bb1ff4$var$BigIntArrayConstructorsList, klass);
};
var $7a7e22a3f2bb1ff4$var$getTypedArrayConstructor = function(it) {
    var proto = $c33537b177d6dc45$exports(it);
    if (!$1dd48fec02de1ab9$exports(proto)) return;
    var state = $7a7e22a3f2bb1ff4$var$getInternalState(proto);
    return state && $b15a118d07a83660$exports(state, $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$7a7e22a3f2bb1ff4$var$TYPED_ARRAY_CONSTRUCTOR] : $7a7e22a3f2bb1ff4$var$getTypedArrayConstructor(proto);
};
var $7a7e22a3f2bb1ff4$var$isTypedArray = function(it) {
    if (!$1dd48fec02de1ab9$exports(it)) return false;
    var klass = $971adb0860c4a3ee$exports(it);
    return $b15a118d07a83660$exports($7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList, klass) || $b15a118d07a83660$exports($7a7e22a3f2bb1ff4$var$BigIntArrayConstructorsList, klass);
};
var $7a7e22a3f2bb1ff4$var$aTypedArray = function(it) {
    if ($7a7e22a3f2bb1ff4$var$isTypedArray(it)) return it;
    throw new $7a7e22a3f2bb1ff4$var$TypeError("Target is not a typed array");
};
var $7a7e22a3f2bb1ff4$var$aTypedArrayConstructor = function(C) {
    if ($7bfc98a4d0d840f1$exports(C) && (!$4ca5bf3591a2dc30$exports || $06399b182ca2f89f$exports($7a7e22a3f2bb1ff4$var$TypedArray, C))) return C;
    throw new $7a7e22a3f2bb1ff4$var$TypeError($dc76b497a74b3a94$exports(C) + " is not a typed array constructor");
};
var $7a7e22a3f2bb1ff4$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$9ff00bcaf2233381$exports) return;
    if (forced) for(var ARRAY in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $2cbb2feed11b0c82$exports[ARRAY];
        if (TypedArrayConstructor && $b15a118d07a83660$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$7a7e22a3f2bb1ff4$var$TypedArrayPrototype[KEY] || forced) $e96fa61102c8705a$exports($7a7e22a3f2bb1ff4$var$TypedArrayPrototype, KEY, forced ? property : $7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS && $7a7e22a3f2bb1ff4$var$Int8ArrayPrototype[KEY] || property, options);
};
var $7a7e22a3f2bb1ff4$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$9ff00bcaf2233381$exports) return;
    if ($4ca5bf3591a2dc30$exports) {
        if (forced) for(ARRAY in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $2cbb2feed11b0c82$exports[ARRAY];
            if (TypedArrayConstructor && $b15a118d07a83660$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$7a7e22a3f2bb1ff4$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $e96fa61102c8705a$exports($7a7e22a3f2bb1ff4$var$TypedArray, KEY, forced ? property : $7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS && $7a7e22a3f2bb1ff4$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $2cbb2feed11b0c82$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $e96fa61102c8705a$exports(TypedArrayConstructor, KEY, property);
    }
};
for($7a7e22a3f2bb1ff4$var$NAME in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList){
    $7a7e22a3f2bb1ff4$var$Constructor = $2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME];
    $7a7e22a3f2bb1ff4$var$Prototype = $7a7e22a3f2bb1ff4$var$Constructor && $7a7e22a3f2bb1ff4$var$Constructor.prototype;
    if ($7a7e22a3f2bb1ff4$var$Prototype) $7a7e22a3f2bb1ff4$var$enforceInternalState($7a7e22a3f2bb1ff4$var$Prototype)[$7a7e22a3f2bb1ff4$var$TYPED_ARRAY_CONSTRUCTOR] = $7a7e22a3f2bb1ff4$var$Constructor;
    else $7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($7a7e22a3f2bb1ff4$var$NAME in $7a7e22a3f2bb1ff4$var$BigIntArrayConstructorsList){
    $7a7e22a3f2bb1ff4$var$Constructor = $2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME];
    $7a7e22a3f2bb1ff4$var$Prototype = $7a7e22a3f2bb1ff4$var$Constructor && $7a7e22a3f2bb1ff4$var$Constructor.prototype;
    if ($7a7e22a3f2bb1ff4$var$Prototype) $7a7e22a3f2bb1ff4$var$enforceInternalState($7a7e22a3f2bb1ff4$var$Prototype)[$7a7e22a3f2bb1ff4$var$TYPED_ARRAY_CONSTRUCTOR] = $7a7e22a3f2bb1ff4$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS || !$7bfc98a4d0d840f1$exports($7a7e22a3f2bb1ff4$var$TypedArray) || $7a7e22a3f2bb1ff4$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $7a7e22a3f2bb1ff4$var$TypedArray = function TypedArray() {
        throw new $7a7e22a3f2bb1ff4$var$TypeError("Incorrect invocation");
    };
    if ($7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($7a7e22a3f2bb1ff4$var$NAME in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList)if ($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME]) $4ca5bf3591a2dc30$exports($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME], $7a7e22a3f2bb1ff4$var$TypedArray);
    }
}
if (!$7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS || !$7a7e22a3f2bb1ff4$var$TypedArrayPrototype || $7a7e22a3f2bb1ff4$var$TypedArrayPrototype === $7a7e22a3f2bb1ff4$var$ObjectPrototype) {
    $7a7e22a3f2bb1ff4$var$TypedArrayPrototype = $7a7e22a3f2bb1ff4$var$TypedArray.prototype;
    if ($7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($7a7e22a3f2bb1ff4$var$NAME in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList)if ($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME]) $4ca5bf3591a2dc30$exports($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME].prototype, $7a7e22a3f2bb1ff4$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS && $c33537b177d6dc45$exports($7a7e22a3f2bb1ff4$var$Uint8ClampedArrayPrototype) !== $7a7e22a3f2bb1ff4$var$TypedArrayPrototype) $4ca5bf3591a2dc30$exports($7a7e22a3f2bb1ff4$var$Uint8ClampedArrayPrototype, $7a7e22a3f2bb1ff4$var$TypedArrayPrototype);
if ($9ff00bcaf2233381$exports && !$b15a118d07a83660$exports($7a7e22a3f2bb1ff4$var$TypedArrayPrototype, $7a7e22a3f2bb1ff4$var$TO_STRING_TAG)) {
    $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $a5dd190846fc6491$exports($7a7e22a3f2bb1ff4$var$TypedArrayPrototype, $7a7e22a3f2bb1ff4$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $1dd48fec02de1ab9$exports(this) ? this[$7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($7a7e22a3f2bb1ff4$var$NAME in $7a7e22a3f2bb1ff4$var$TypedArrayConstructorsList)if ($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME]) $20d431cd936788d2$exports($2cbb2feed11b0c82$exports[$7a7e22a3f2bb1ff4$var$NAME], $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG, $7a7e22a3f2bb1ff4$var$NAME);
}
$7a7e22a3f2bb1ff4$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $7a7e22a3f2bb1ff4$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG_REQUIRED && $7a7e22a3f2bb1ff4$var$TYPED_ARRAY_TAG,
    aTypedArray: $7a7e22a3f2bb1ff4$var$aTypedArray,
    aTypedArrayConstructor: $7a7e22a3f2bb1ff4$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $7a7e22a3f2bb1ff4$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $7a7e22a3f2bb1ff4$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $7a7e22a3f2bb1ff4$var$getTypedArrayConstructor,
    isView: $7a7e22a3f2bb1ff4$var$isView,
    isTypedArray: $7a7e22a3f2bb1ff4$var$isTypedArray,
    TypedArray: $7a7e22a3f2bb1ff4$var$TypedArray,
    TypedArrayPrototype: $7a7e22a3f2bb1ff4$var$TypedArrayPrototype
};


var $6194be51e8db427d$exports = {};
"use strict";
var $2b7dd6ec1f5444a4$exports = {};
"use strict";
var $a891b10f7bb5503d$exports = {};
"use strict";
var $b19746cc3f7868d2$exports = {};
"use strict";
var $b19746cc3f7868d2$var$ceil = Math.ceil;
var $b19746cc3f7868d2$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$b19746cc3f7868d2$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $b19746cc3f7868d2$var$floor : $b19746cc3f7868d2$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$a891b10f7bb5503d$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $b19746cc3f7868d2$exports(number);
};


var $2b7dd6ec1f5444a4$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$2b7dd6ec1f5444a4$exports = function(argument) {
    var len = $a891b10f7bb5503d$exports(argument);
    return len > 0 ? $2b7dd6ec1f5444a4$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$6194be51e8db427d$exports = function(obj) {
    return $2b7dd6ec1f5444a4$exports(obj.length);
};


var $63d8fe521287cff8$exports = {};
"use strict";
var $2d625bf89e9464df$exports = {};
"use strict";

var $2d625bf89e9464df$var$$RangeError = RangeError;
$2d625bf89e9464df$exports = function(it) {
    var result = $a891b10f7bb5503d$exports(it);
    if (result < 0) throw new $2d625bf89e9464df$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $63d8fe521287cff8$var$$RangeError = RangeError;
$63d8fe521287cff8$exports = function(it, BYTES) {
    var offset = $2d625bf89e9464df$exports(it);
    if (offset % BYTES) throw new $63d8fe521287cff8$var$$RangeError("Wrong offset");
    return offset;
};




var $a5ad661e4151738c$var$RangeError = $2cbb2feed11b0c82$exports.RangeError;
var $a5ad661e4151738c$var$Int8Array = $2cbb2feed11b0c82$exports.Int8Array;
var $a5ad661e4151738c$var$Int8ArrayPrototype = $a5ad661e4151738c$var$Int8Array && $a5ad661e4151738c$var$Int8Array.prototype;
var $a5ad661e4151738c$var$$set = $a5ad661e4151738c$var$Int8ArrayPrototype && $a5ad661e4151738c$var$Int8ArrayPrototype.set;
var $a5ad661e4151738c$var$aTypedArray = $7a7e22a3f2bb1ff4$exports.aTypedArray;
var $a5ad661e4151738c$var$exportTypedArrayMethod = $7a7e22a3f2bb1ff4$exports.exportTypedArrayMethod;
var $a5ad661e4151738c$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$559f5eda2886c38a$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $435486dccf283463$exports($a5ad661e4151738c$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $a5ad661e4151738c$var$TO_OBJECT_BUG = $a5ad661e4151738c$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $7a7e22a3f2bb1ff4$exports.NATIVE_ARRAY_BUFFER_VIEWS && $559f5eda2886c38a$exports(function() {
    var array = new $a5ad661e4151738c$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$a5ad661e4151738c$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $a5ad661e4151738c$var$aTypedArray(this);
    var offset = $63d8fe521287cff8$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $f044d2da435198e8$exports(arrayLike);
    if ($a5ad661e4151738c$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $435486dccf283463$exports($a5ad661e4151738c$var$$set, this, src, offset);
    var length = this.length;
    var len = $6194be51e8db427d$exports(src);
    var index = 0;
    if (len + offset > length) throw new $a5ad661e4151738c$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$a5ad661e4151738c$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $a5ad661e4151738c$var$TO_OBJECT_BUG);


"use strict";
"use strict";
var $f79ea3f460c1434e$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $1763022b378afbc9$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $0d1cd342ca05bb81$export$2d1720544b23b823;
"use strict";
var $0d1cd342ca05bb81$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0d1cd342ca05bb81$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $0d1cd342ca05bb81$var$NASHORN_BUG = $0d1cd342ca05bb81$var$getOwnPropertyDescriptor && !$0d1cd342ca05bb81$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$0d1cd342ca05bb81$export$2d1720544b23b823 = $0d1cd342ca05bb81$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $0d1cd342ca05bb81$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $0d1cd342ca05bb81$var$$propertyIsEnumerable;



var $75c532612d3a0685$exports = {};
"use strict";
var $7be64a2ac086c360$exports = {};
"use strict";



var $7be64a2ac086c360$var$$Object = Object;
var $7be64a2ac086c360$var$split = $034d34ba5c67196d$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$7be64a2ac086c360$exports = $559f5eda2886c38a$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$7be64a2ac086c360$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $fccbf27112ab4253$exports(it) === "String" ? $7be64a2ac086c360$var$split(it, "") : $7be64a2ac086c360$var$$Object(it);
} : $7be64a2ac086c360$var$$Object;



$75c532612d3a0685$exports = function(it) {
    return $7be64a2ac086c360$exports($ffc260fd1baed7a7$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1763022b378afbc9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$1763022b378afbc9$export$2d1720544b23b823 = $9ff00bcaf2233381$exports ? $1763022b378afbc9$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $75c532612d3a0685$exports(O);
    P = $1f05d412889afb5f$exports(P);
    if ($669235fed8991415$exports) try {
        return $1763022b378afbc9$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($b15a118d07a83660$exports(O, P)) return $5fae5d41462f758e$exports(!$435486dccf283463$exports($0d1cd342ca05bb81$export$2d1720544b23b823, O, P), O[P]);
};


var $f79ea3f460c1434e$require$getOwnPropertyDescriptor = $1763022b378afbc9$export$2d1720544b23b823;



var $a161f019781d9d12$exports = {};
"use strict";

var $03be0d5486559ebf$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $57ae34cabc2bbd2c$export$2d1720544b23b823;
"use strict";
var $8e7d4ab8f18c4b4d$exports = {};
"use strict";



var $9128512e22ef3888$exports = {};
"use strict";

var $04f02a421daebf93$exports = {};
"use strict";

var $04f02a421daebf93$var$max = Math.max;
var $04f02a421daebf93$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$04f02a421daebf93$exports = function(index, length) {
    var integer = $a891b10f7bb5503d$exports(index);
    return integer < 0 ? $04f02a421daebf93$var$max(integer + length, 0) : $04f02a421daebf93$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $9128512e22ef3888$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $75c532612d3a0685$exports($this);
        var length = $6194be51e8db427d$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $04f02a421daebf93$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$9128512e22ef3888$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $9128512e22ef3888$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $9128512e22ef3888$var$createMethod(false)
};


var $8e7d4ab8f18c4b4d$require$indexOf = $9128512e22ef3888$exports.indexOf;

var $8e7d4ab8f18c4b4d$var$push = $034d34ba5c67196d$exports([].push);
$8e7d4ab8f18c4b4d$exports = function(object, names) {
    var O = $75c532612d3a0685$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$b15a118d07a83660$exports($b1e7c6c731f3486d$exports, key) && $b15a118d07a83660$exports(O, key) && $8e7d4ab8f18c4b4d$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($b15a118d07a83660$exports(O, key = names[i++])) ~$8e7d4ab8f18c4b4d$require$indexOf(result, key) || $8e7d4ab8f18c4b4d$var$push(result, key);
    return result;
};


var $ee604605f1fed968$exports = {};
"use strict";
// IE8- don't enum bug keys
$ee604605f1fed968$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $57ae34cabc2bbd2c$var$hiddenKeys = $ee604605f1fed968$exports.concat("length", "prototype");
$57ae34cabc2bbd2c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $8e7d4ab8f18c4b4d$exports(O, $57ae34cabc2bbd2c$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $353730c2b05b4b06$export$2d1720544b23b823;
"use strict";
$353730c2b05b4b06$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $03be0d5486559ebf$var$concat = $034d34ba5c67196d$exports([].concat);
// all object keys, includes non-enumerable and symbols
$03be0d5486559ebf$exports = $8eca1fe746def71f$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $57ae34cabc2bbd2c$export$2d1720544b23b823($bdf4e31e832353ba$exports(it));
    var getOwnPropertySymbols = $353730c2b05b4b06$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $03be0d5486559ebf$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$a161f019781d9d12$exports = function(target, source, exceptions) {
    var keys = $03be0d5486559ebf$exports(source);
    var defineProperty = $385c93b930cc413c$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $1763022b378afbc9$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$b15a118d07a83660$exports(target, key) && !(exceptions && $b15a118d07a83660$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $8a13f083ebba5b1e$exports = {};
"use strict";


var $8a13f083ebba5b1e$var$replacement = /#|\.prototype\./;
var $8a13f083ebba5b1e$var$isForced = function(feature, detection) {
    var value = $8a13f083ebba5b1e$var$data[$8a13f083ebba5b1e$var$normalize(feature)];
    return value === $8a13f083ebba5b1e$var$POLYFILL ? true : value === $8a13f083ebba5b1e$var$NATIVE ? false : $7bfc98a4d0d840f1$exports(detection) ? $559f5eda2886c38a$exports(detection) : !!detection;
};
var $8a13f083ebba5b1e$var$normalize = $8a13f083ebba5b1e$var$isForced.normalize = function(string) {
    return String(string).replace($8a13f083ebba5b1e$var$replacement, ".").toLowerCase();
};
var $8a13f083ebba5b1e$var$data = $8a13f083ebba5b1e$var$isForced.data = {};
var $8a13f083ebba5b1e$var$NATIVE = $8a13f083ebba5b1e$var$isForced.NATIVE = "N";
var $8a13f083ebba5b1e$var$POLYFILL = $8a13f083ebba5b1e$var$isForced.POLYFILL = "P";
$8a13f083ebba5b1e$exports = $8a13f083ebba5b1e$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $f79ea3f460c1434e$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $2cbb2feed11b0c82$exports;
    else if (STATIC) target = $2cbb2feed11b0c82$exports[TARGET] || $8a688362be0e540d$exports(TARGET, {});
    else target = $2cbb2feed11b0c82$exports[TARGET] && $2cbb2feed11b0c82$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f79ea3f460c1434e$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $8a13f083ebba5b1e$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $a161f019781d9d12$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $20d431cd936788d2$exports(sourceProperty, "sham", true);
        $e96fa61102c8705a$exports(target, key, sourceProperty, options);
    }
};



var $baf13049332391d1$exports = {};
"use strict";

var $3eb6e251025b649f$exports = {};
"use strict";

var $3eb6e251025b649f$var$FunctionPrototype = Function.prototype;
var $3eb6e251025b649f$var$apply = $3eb6e251025b649f$var$FunctionPrototype.apply;
var $3eb6e251025b649f$var$call = $3eb6e251025b649f$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$3eb6e251025b649f$exports = typeof Reflect == "object" && Reflect.apply || ($2b364aaec2774fa2$exports ? $3eb6e251025b649f$var$call.bind($3eb6e251025b649f$var$apply) : function() {
    return $3eb6e251025b649f$var$call.apply($3eb6e251025b649f$var$apply, arguments);
});


var $9775cc42a10771d9$exports = {};
"use strict";
var $476ca98aaaeab51d$exports = {};
"use strict";


$476ca98aaaeab51d$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($fccbf27112ab4253$exports(fn) === "Function") return $034d34ba5c67196d$exports(fn);
};




var $9775cc42a10771d9$var$bind = $476ca98aaaeab51d$exports($476ca98aaaeab51d$exports.bind);
// optional / simple context binding
$9775cc42a10771d9$exports = function(fn, that) {
    $cbc0300673cdb7ee$exports(fn);
    return that === undefined ? fn : $2b364aaec2774fa2$exports ? $9775cc42a10771d9$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $439273fa152f702f$exports = {};
"use strict";

$439273fa152f702f$exports = $8eca1fe746def71f$exports("document", "documentElement");


var $f5ee721bbba19b1c$exports = {};
"use strict";

$f5ee721bbba19b1c$exports = $034d34ba5c67196d$exports([].slice);



var $bf2db13d79d69906$exports = {};
"use strict";
var $bf2db13d79d69906$var$$TypeError = TypeError;
$bf2db13d79d69906$exports = function(passed, required) {
    if (passed < required) throw new $bf2db13d79d69906$var$$TypeError("Not enough arguments");
    return passed;
};


var $8b099aac65010499$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$8b099aac65010499$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($ddf1d285fb7076b6$exports);


var $9f17619523e37fb8$exports = {};
"use strict";


$9f17619523e37fb8$exports = $fccbf27112ab4253$exports($2cbb2feed11b0c82$exports.process) === "process";


var $baf13049332391d1$var$set = $2cbb2feed11b0c82$exports.setImmediate;
var $baf13049332391d1$var$clear = $2cbb2feed11b0c82$exports.clearImmediate;
var $baf13049332391d1$var$process = $2cbb2feed11b0c82$exports.process;
var $baf13049332391d1$var$Dispatch = $2cbb2feed11b0c82$exports.Dispatch;
var $baf13049332391d1$var$Function = $2cbb2feed11b0c82$exports.Function;
var $baf13049332391d1$var$MessageChannel = $2cbb2feed11b0c82$exports.MessageChannel;
var $baf13049332391d1$var$String = $2cbb2feed11b0c82$exports.String;
var $baf13049332391d1$var$counter = 0;
var $baf13049332391d1$var$queue = {};
var $baf13049332391d1$var$ONREADYSTATECHANGE = "onreadystatechange";
var $baf13049332391d1$var$$location, $baf13049332391d1$var$defer, $baf13049332391d1$var$channel, $baf13049332391d1$var$port;
$559f5eda2886c38a$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $baf13049332391d1$var$$location = $2cbb2feed11b0c82$exports.location;
});
var $baf13049332391d1$var$run = function(id) {
    if ($b15a118d07a83660$exports($baf13049332391d1$var$queue, id)) {
        var fn = $baf13049332391d1$var$queue[id];
        delete $baf13049332391d1$var$queue[id];
        fn();
    }
};
var $baf13049332391d1$var$runner = function(id) {
    return function() {
        $baf13049332391d1$var$run(id);
    };
};
var $baf13049332391d1$var$eventListener = function(event) {
    $baf13049332391d1$var$run(event.data);
};
var $baf13049332391d1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $2cbb2feed11b0c82$exports.postMessage($baf13049332391d1$var$String(id), $baf13049332391d1$var$$location.protocol + "//" + $baf13049332391d1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$baf13049332391d1$var$set || !$baf13049332391d1$var$clear) {
    $baf13049332391d1$var$set = function setImmediate(handler) {
        $bf2db13d79d69906$exports(arguments.length, 1);
        var fn = $7bfc98a4d0d840f1$exports(handler) ? handler : $baf13049332391d1$var$Function(handler);
        var args = $f5ee721bbba19b1c$exports(arguments, 1);
        $baf13049332391d1$var$queue[++$baf13049332391d1$var$counter] = function() {
            $3eb6e251025b649f$exports(fn, undefined, args);
        };
        $baf13049332391d1$var$defer($baf13049332391d1$var$counter);
        return $baf13049332391d1$var$counter;
    };
    $baf13049332391d1$var$clear = function clearImmediate(id) {
        delete $baf13049332391d1$var$queue[id];
    };
    // Node.js 0.8-
    if ($9f17619523e37fb8$exports) $baf13049332391d1$var$defer = function(id) {
        $baf13049332391d1$var$process.nextTick($baf13049332391d1$var$runner(id));
    };
    else if ($baf13049332391d1$var$Dispatch && $baf13049332391d1$var$Dispatch.now) $baf13049332391d1$var$defer = function(id) {
        $baf13049332391d1$var$Dispatch.now($baf13049332391d1$var$runner(id));
    };
    else if ($baf13049332391d1$var$MessageChannel && !$8b099aac65010499$exports) {
        $baf13049332391d1$var$channel = new $baf13049332391d1$var$MessageChannel();
        $baf13049332391d1$var$port = $baf13049332391d1$var$channel.port2;
        $baf13049332391d1$var$channel.port1.onmessage = $baf13049332391d1$var$eventListener;
        $baf13049332391d1$var$defer = $9775cc42a10771d9$exports($baf13049332391d1$var$port.postMessage, $baf13049332391d1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($2cbb2feed11b0c82$exports.addEventListener && $7bfc98a4d0d840f1$exports($2cbb2feed11b0c82$exports.postMessage) && !$2cbb2feed11b0c82$exports.importScripts && $baf13049332391d1$var$$location && $baf13049332391d1$var$$location.protocol !== "file:" && !$559f5eda2886c38a$exports($baf13049332391d1$var$globalPostMessageDefer)) {
        $baf13049332391d1$var$defer = $baf13049332391d1$var$globalPostMessageDefer;
        $2cbb2feed11b0c82$exports.addEventListener("message", $baf13049332391d1$var$eventListener, false);
    // IE8-
    } else if ($baf13049332391d1$var$ONREADYSTATECHANGE in $5307871634ee9684$exports("script")) $baf13049332391d1$var$defer = function(id) {
        $439273fa152f702f$exports.appendChild($5307871634ee9684$exports("script"))[$baf13049332391d1$var$ONREADYSTATECHANGE] = function() {
            $439273fa152f702f$exports.removeChild(this);
            $baf13049332391d1$var$run(id);
        };
    };
    else $baf13049332391d1$var$defer = function(id) {
        setTimeout($baf13049332391d1$var$runner(id), 0);
    };
}
$baf13049332391d1$exports = {
    set: $baf13049332391d1$var$set,
    clear: $baf13049332391d1$var$clear
};


var $873163ce0154c3b6$require$clearImmediate = $baf13049332391d1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$f79ea3f460c1434e$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $2cbb2feed11b0c82$exports.clearImmediate !== $873163ce0154c3b6$require$clearImmediate
}, {
    clearImmediate: $873163ce0154c3b6$require$clearImmediate
});


"use strict";



var $f1fb7d1ef1bd8651$require$setTask = $baf13049332391d1$exports.set;
var $2726d8b041062215$exports = {};
"use strict";



var $c1b5a7684443aab3$exports = {};
"use strict";
/* global Bun -- Bun case */ $c1b5a7684443aab3$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $2726d8b041062215$var$Function = $2cbb2feed11b0c82$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $2726d8b041062215$var$WRAP = /MSIE .\./.test($ddf1d285fb7076b6$exports) || $c1b5a7684443aab3$exports && function() {
    var version = $2cbb2feed11b0c82$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$2726d8b041062215$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $2726d8b041062215$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $bf2db13d79d69906$exports(arguments.length, 1) > firstParamIndex;
        var fn = $7bfc98a4d0d840f1$exports(handler) ? handler : $2726d8b041062215$var$Function(handler);
        var params = boundArgs ? $f5ee721bbba19b1c$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3eb6e251025b649f$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $f1fb7d1ef1bd8651$var$setImmediate = $2cbb2feed11b0c82$exports.setImmediate ? $2726d8b041062215$exports($f1fb7d1ef1bd8651$require$setTask, false) : $f1fb7d1ef1bd8651$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$f79ea3f460c1434e$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $2cbb2feed11b0c82$exports.setImmediate !== $f1fb7d1ef1bd8651$var$setImmediate
}, {
    setImmediate: $f1fb7d1ef1bd8651$var$setImmediate
});




const $a536fbf06af412b5$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes/";
const $a536fbf06af412b5$export$9bec5134f7f38b3a = 10;
const $a536fbf06af412b5$export$d2f17d20365655cb = 10;
const $a536fbf06af412b5$export$a9861bd62f48e142 = "a9f86c6d-8f14-4d44-a7e9-2508a0e9b275";
const $a536fbf06af412b5$export$3ce8858248d89a69 = 2.5;



const $cc162643f2dbb23c$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $cc162643f2dbb23c$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPro = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPro,
            $cc162643f2dbb23c$var$timeout((0, $a536fbf06af412b5$export$9bec5134f7f38b3a))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (e) {
        throw e;
    }
}; // export const getJSON = async url => {
 //   try {
 //     const res = await Promise.race([fetch(url), timeout(TIMEOUT_SECONDS)]);
 //     const data = await res.json();
 //
 //     if (!res.ok) throw new Error(`${data.message} (${res.status})`);
 //
 //     return data;
 //   } catch (e) {
 //     throw e;
 //   }
 // };
 //
 // export const sendJSON = async (url, uploadData) => {
 //   try {
 //     const fetchPro = fetch(url, {
 //       method: 'POST',
 //       headers: {
 //         'Content-Type': 'application/json',
 //       },
 //       body: JSON.stringify(uploadData),
 //     });
 //
 //     const res = await Promise.race([fetchPro, timeout(TIMEOUT_SECONDS)]);
 //     const data = await res.json();
 //
 //     if (!res.ok) throw new Error(`${data.message} (${res.status})`);
 //
 //     return data;
 //   } catch (e) {
 //     throw e;
 //   }
 // };


const $40873ecf3c18e122$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        resultsPerPage: (0, $a536fbf06af412b5$export$d2f17d20365655cb),
        page: 1
    },
    bookmarks: []
};
const $40873ecf3c18e122$var$createRecipeObject = function(data) {
    const { recipe: recipe } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $40873ecf3c18e122$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $cc162643f2dbb23c$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}${id}?key=${(0, $a536fbf06af412b5$export$a9861bd62f48e142)}`);
        $40873ecf3c18e122$export$ca000e230c0caa3e.recipe = $40873ecf3c18e122$var$createRecipeObject(data);
        if ($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks.some((b)=>b.id === id)) $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.bookmarked = true;
    //console.log(data.data, state.recipe);
    } catch (e) {
        throw e;
    }
};
const $40873ecf3c18e122$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $40873ecf3c18e122$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $cc162643f2dbb23c$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?search=${query}&key=${(0, $a536fbf06af412b5$export$a9861bd62f48e142)}`);
        $40873ecf3c18e122$export$ca000e230c0caa3e.search.results = data.data.recipes.map((recipe)=>{
            return {
                id: recipe.id,
                title: recipe.title,
                publisher: recipe.publisher,
                image: recipe.image_url,
                ...recipe.key && {
                    key: recipe.key
                }
            };
        });
        $40873ecf3c18e122$export$ca000e230c0caa3e.search.page = 1;
    } catch (e) {
        throw e;
    }
};
const $40873ecf3c18e122$export$8d7f79465139ab72 = function(page = $40873ecf3c18e122$export$ca000e230c0caa3e.search.page) {
    $40873ecf3c18e122$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $40873ecf3c18e122$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $40873ecf3c18e122$export$ca000e230c0caa3e.search.resultsPerPage;
    return $40873ecf3c18e122$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $40873ecf3c18e122$export$5e23f4642ecad5ea = function(newServings) {
    $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.servings;
    });
    $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.servings = newServings;
};
const $40873ecf3c18e122$var$persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks));
};
const $40873ecf3c18e122$export$72009cc673d27d80 = function(recipe) {
    $40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks.push(recipe);
    if (recipe.id === $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.id) $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $40873ecf3c18e122$var$persistBookmarks();
};
const $40873ecf3c18e122$export$136048bcb9946c75 = function(id) {
    const index = $40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    $40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.id) $40873ecf3c18e122$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $40873ecf3c18e122$var$persistBookmarks();
};
const $40873ecf3c18e122$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$40873ecf3c18e122$var$init();
const $40873ecf3c18e122$var$clearBookmarks = function() {
    localStorage.clear("bookmarks");
};
const $40873ecf3c18e122$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ing)=>{
            const ingArr = ing[1].split(",").map((el)=>el.trim());
            // const ingArr = ing[1].replaceAll(' ', '').split(',');
            if (ingArr.length !== 3) throw new Error("Wrong ingredient fromat! Please use the correct format :)");
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $cc162643f2dbb23c$export$2b3ff41fecbef7c8)(`${(0, $a536fbf06af412b5$export$923ea8233b386e99)}?key=${(0, $a536fbf06af412b5$export$a9861bd62f48e142)}`, recipe);
        $40873ecf3c18e122$export$ca000e230c0caa3e.recipe = $40873ecf3c18e122$var$createRecipeObject(data);
        $40873ecf3c18e122$export$72009cc673d27d80($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
    } catch (e) {
        throw e;
    }
};


var $a922e5462747601b$exports = {};

$a922e5462747601b$exports = (parcelRequire("aNJCr")).getBundleURL("4ko55") + "icons.c14567a0.svg";


class $e2f42d17993acde2$export$2e2bcd8739ae039 {
    _parentElement = document.querySelector(".recipe");
    _data;
    _errorMessage;
    _message;
    render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // console.log(curEl, newEl.isEqualNode(curEl));
            // Updates changed TEXT
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") // console.log('💥', newEl.firstChild.nodeValue.trim());
            curEl.textContent = newEl.textContent;
            // Updates changed ATTRIBUES
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
    renderSpinner() {
        const markup = `
    <div class="spinner">
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-loader"></use>
      </svg>
    </div> 
  `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderError(msg = this._errorMessage) {
        const markup = `
      <div class="error">
          <div>
            <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-alert-triangle"></use>
            </svg>
          </div>
          <p>${msg}</p>
      </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    renderMessage(msg = this._message) {
        const markup = `
      <div class="message">
          <div>
            <svg>
              <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports)))}#icon-smile"></use>
            </svg>
          </div>
          <p>${msg}</p>
      </div>
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}



var $b0f2bd7507f92d39$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$b0f2bd7507f92d39$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $b0f2bd7507f92d39$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $b0f2bd7507f92d39$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $b0f2bd7507f92d39$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $b0f2bd7507f92d39$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


// <svg>
//   <use href="${icons}#icon-user"></use>
// </svg>
class $ea0bcfdcc0e4bdd1$var$RecipeView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    _errorMessage = "No recipes found for your query. Please try again :)";
    _message = "";
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--tiny");
            if (!btn) return;
            const newServings = +btn.dataset.update;
            if (newServings > 0) handler(newServings);
        });
    }
    addHandlerAddBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
    _generateMarkup() {
        return `
      <figure class="recipe__fig">
        <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
        <h1 class="recipe__title">
          <span>${this._data.title}</span>
        </h1>
      </figure>
  
      <div class="recipe__details">
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-clock"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
          <span class="recipe__info-text">minutes</span>
        </div>
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-users"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
          <span class="recipe__info-text">servings</span>
  
          <div class="recipe__info-buttons">
            <button data-update="${this._data.servings - 1}" class="btn--tiny btn--increase-servings">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-minus-circle"></use>
              </svg>
            </button>
            <button data-update="${this._data.servings + 1}"  class="btn--tiny btn--increase-servings">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-plus-circle"></use>
              </svg>
            </button>
          </div>
        </div>
  
        <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-user"></use>
            </svg>
        </div>
        <button class="btn--round btn--bookmark">
          <svg class="">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
          </svg>
        </button>
      </div>
  
      <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
          ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}
        </ul>
      </div>
  
      <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
          This recipe was carefully designed and tested by
          <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
          directions at their website.
        </p>
        <a
          class="btn--small recipe__btn"
          href="${this._data.sourceUrl}"
          target="_blank"
        >
          <span>Directions</span>
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-right"></use>
          </svg>
        </a>
      </div>
    `;
    }
    _generateMarkupIngredient(ing) {
        return `
        <li class="recipe__ingredient">
          <svg class="recipe__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-check"></use>
          </svg>
          <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($b0f2bd7507f92d39$exports)))(ing.quantity) : ""}</div>
          <div class="recipe__description">
            <span class="recipe__unit">${ing.unit}</span>
            ${ing.description}
          </div>
         </li>
      `;
    }
}
var $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039 = new $ea0bcfdcc0e4bdd1$var$RecipeView();



class $4ecae68ace29302e$var$SearchView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".search");
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $4ecae68ace29302e$export$2e2bcd8739ae039 = new $4ecae68ace29302e$var$SearchView();






class $80a3dd18d73213a2$var$PreviewView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
      <li class="preview">
        <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
          <figure class="preview__fig">
            <img src="${this._data.image}" alt="${this._data.title}" />
          </figure>
          <div class="preview__data">
            <h4 class="preview__title">${this._data.title}</h4>
            <p class="preview__publisher">${this._data.publisher}</p>
          </div>
            <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-user"></use>
              </svg>
            </div>
          
        </a>
      </li>
    `;
    }
}
var $80a3dd18d73213a2$export$2e2bcd8739ae039 = new $80a3dd18d73213a2$var$PreviewView();


class $b0a85915cf18e6a9$var$ResultsView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipes found for your query. Please try again!";
    _message = "";
    _generateMarkup() {
        return this._data.map((result)=>(0, $80a3dd18d73213a2$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $b0a85915cf18e6a9$export$2e2bcd8739ae039 // <div className="preview__user-generated">
 //   <svg>
 //     <use href="${icons}#icon-user"></use>
 //   </svg>
 // </div>
 = new $b0a85915cf18e6a9$var$ResultsView();





class $4ca9b3632514c12c$var$BookmarksView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it ;)";
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmark)=>(0, $80a3dd18d73213a2$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $4ca9b3632514c12c$export$2e2bcd8739ae039 // <div className="preview__user-generated">
 //   <svg>
 //     <use href="${icons}#icon-user"></use>
 //   </svg>
 // </div>
 = new $4ca9b3632514c12c$var$BookmarksView();




class $98538cce37c15c95$var$PaginationView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    addHandlerCLick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkup() {
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        const curPage = this._data.page;
        if (curPage === 1 && numPages > 1) return this._generateMarkupButton(curPage, {
            prev: false,
            next: true
        });
        if (curPage === numPages && numPages > 1) return this._generateMarkupButton(curPage, {
            prev: true,
            next: false
        });
        if (curPage < numPages) return this._generateMarkupButton(curPage, {
            prev: true,
            next: true
        });
        return "";
    }
    _generateMarkupButton(page, prevNext) {
        const prevButton = prevNext.prev ? `
      <button data-goto="${page - 1}" class="btn--inline pagination__btn--prev">
         <svg class="search__icon">
           <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-left"></use>
         </svg>
         <span>Page ${page - 1}</span>
       </button>
    ` : "";
        const nextButton = prevNext.next ? `
      <button data-goto="${page + 1}" class="btn--inline pagination__btn--next">
         <span>Page ${page + 1}</span>
         <svg class="search__icon">
           <use href="${0, (/*@__PURE__*/$parcel$interopDefault($a922e5462747601b$exports))}#icon-arrow-right"></use>
         </svg>
      </button>
    ` : "";
        return prevButton + nextButton;
    }
}
var $98538cce37c15c95$export$2e2bcd8739ae039 = new $98538cce37c15c95$var$PaginationView();




class $a42a5ec275abd6a0$var$AddRecipeView extends (0, $e2f42d17993acde2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _message = "Recipe was successfully uploaded :)";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        [
            this._btnClose,
            this._overlay
        ].forEach((node)=>node.addEventListener("click", this.toggleWindow.bind(this)));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArray = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArray);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $a42a5ec275abd6a0$export$2e2bcd8739ae039 = new $a42a5ec275abd6a0$var$AddRecipeView();


var $21b983287c82ebd3$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $21b983287c82ebd3$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $21b983287c82ebd3$exports));
try {
    regeneratorRuntime = $21b983287c82ebd3$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $21b983287c82ebd3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($21b983287c82ebd3$var$runtime);
}



const $cdc8bba1cf7e6fe0$var$controlRecipe = async function() {
    try {
        //get recipe id
        const id = window.location.hash.slice(1);
        //console.log(id);
        if (!id) return;
        (0, $b0a85915cf18e6a9$export$2e2bcd8739ae039).update($40873ecf3c18e122$export$8d7f79465139ab72());
        (0, $4ca9b3632514c12c$export$2e2bcd8739ae039).update($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks);
        //render spinner
        (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).renderSpinner();
        //load recipe
        await $40873ecf3c18e122$export$b96725c7a035d60b(id);
        //render recipe
        (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).renderError();
    }
};
const $cdc8bba1cf7e6fe0$var$controlSearchResults = async function() {
    try {
        (0, $b0a85915cf18e6a9$export$2e2bcd8739ae039).renderSpinner();
        const query = (0, $4ecae68ace29302e$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        await $40873ecf3c18e122$export$202b8e5cb363a0c4(query);
        (0, $b0a85915cf18e6a9$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$8d7f79465139ab72());
        (0, $98538cce37c15c95$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.search);
    } catch (e) {
        console.log(e);
    }
};
const $cdc8bba1cf7e6fe0$var$controlPagination = function(gotToPage) {
    (0, $b0a85915cf18e6a9$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$8d7f79465139ab72(gotToPage));
    (0, $98538cce37c15c95$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.search);
};
const $cdc8bba1cf7e6fe0$var$controlServings = function(newServings) {
    // update the recipe servings
    $40873ecf3c18e122$export$5e23f4642ecad5ea(newServings);
    // update the recipe view
    // recipeView.render(modal.state.recipe);
    (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).update($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
};
const $cdc8bba1cf7e6fe0$var$controlAddBookmark = function() {
    if (!$40873ecf3c18e122$export$ca000e230c0caa3e.recipe.bookmarked) $40873ecf3c18e122$export$72009cc673d27d80($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
    else $40873ecf3c18e122$export$136048bcb9946c75($40873ecf3c18e122$export$ca000e230c0caa3e.recipe.id);
    (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).update($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
    (0, $4ca9b3632514c12c$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlBookmarks = function() {
    (0, $4ca9b3632514c12c$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks);
};
const $cdc8bba1cf7e6fe0$var$controlAddRecipe = async function(newRecipe) {
    try {
        (0, $a42a5ec275abd6a0$export$2e2bcd8739ae039).renderSpinner();
        await $40873ecf3c18e122$export$d660c2254e74960d(newRecipe);
        // console.log(modal.state.recipe);
        (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.recipe);
        (0, $a42a5ec275abd6a0$export$2e2bcd8739ae039).renderMessage();
        (0, $4ca9b3632514c12c$export$2e2bcd8739ae039).render($40873ecf3c18e122$export$ca000e230c0caa3e.bookmarks);
        window.history.pushState(null, "", `#${$40873ecf3c18e122$export$ca000e230c0caa3e.recipe.id}`);
        setTimeout(function() {
            (0, $a42a5ec275abd6a0$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $a536fbf06af412b5$export$3ce8858248d89a69) * 1000);
    } catch (e) {
        console.error(e);
        (0, $a42a5ec275abd6a0$export$2e2bcd8739ae039).renderError(e.message);
    }
};
const $cdc8bba1cf7e6fe0$var$init = function() {
    (0, $4ca9b3632514c12c$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlBookmarks);
    (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).addHandlerRender($cdc8bba1cf7e6fe0$var$controlRecipe);
    (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).addHandlerUpdateServings($cdc8bba1cf7e6fe0$var$controlServings);
    (0, $ea0bcfdcc0e4bdd1$export$2e2bcd8739ae039).addHandlerAddBookmark($cdc8bba1cf7e6fe0$var$controlAddBookmark);
    (0, $4ecae68ace29302e$export$2e2bcd8739ae039).addHandlerSearch($cdc8bba1cf7e6fe0$var$controlSearchResults);
    (0, $98538cce37c15c95$export$2e2bcd8739ae039).addHandlerCLick($cdc8bba1cf7e6fe0$var$controlPagination);
    (0, $a42a5ec275abd6a0$export$2e2bcd8739ae039).addHandlerUpload($cdc8bba1cf7e6fe0$var$controlAddRecipe);
};
$cdc8bba1cf7e6fe0$var$init();

})();
//# sourceMappingURL=index.0c2127df.js.map
